/*
 * File: ThemeToggle.tsx
 * Project: rosita
 * -----
 * Copyright (c) 2023 Elegant Software Solutions All rights reserved.
 */

import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { toggleTheme } from 'redux/slices/appSlice';
import { useAppDispatch, useAppSelector } from 'redux/store';
import './ThemeToggle.css';

export const ThemeToggle = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { theme } = useAppSelector((state) => state.app);

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  return (
    <div style={{ opacity: 0.8 }}>
      <Button
        onClick={handleToggle}
        shape="circle"
        className={`theme-toggle-btn ${theme !== 'light' ? 'light-theme' : 'dark-theme'}`}
        icon={theme !== 'light' ? <SunOutlined style={{ color: '#fff' }} /> : <MoonOutlined style={{ color: '#000' }} />}
        // type={theme === 'light' ? 'primary' : 'default'}
        style={{ backgroundColor: theme !== 'light' ? '#1f1e2e' : '#f0f2f5', border: theme !== 'light' ? '1px solid #fff' : '1px solid #d9d9d9' }}
      />
    </div>
  );
};
